import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import DRNText from '../../standard/Text/DRNText';
import R from '../../core-res/R';
import DRNImage from '../../standard/Image/DRNImage';
import imageRenderer from './ImageRenderer';
import { withTheme } from '../../theme';
const Styles = StyleSheet.create({
    container: {
        paddingBottom: R.spacing.m,
        borderRadius: R.border.radius.default,
    },
    title: {
        paddingVertical: R.spacing.ml,
        paddingHorizontal: R.spacing.m,
    },
    close: {
        position: 'absolute',
        right: R.spacing.m,
        top: R.spacing.m,
        width: R.spacing.l,
        height: R.spacing.l,
        zIndex: 1,
        borderRadius: R.border.radius.default,
        overflow: 'hidden',
    },
    content: {
        paddingHorizontal: R.spacing.m,
        paddingTop: R.spacing.xs,
    },
    gradientWrapper: {
        borderTopLeftRadius: R.border.radius.default,
        borderTopRightRadius: R.border.radius.default,
    },
});
function Popup(props) {
    const { width, height, children, image, showCloseButton, title, onCloseButtonPress, maxWidth, minHeight, theme, closeButtonSmartKey, } = props;
    const tintColor = image ? theme.lightPrimary : theme.darkSecondary;
    const backgroundColor = theme.lightPrimary;
    return (<View style={[Styles.container, { width, height, maxWidth, minHeight, backgroundColor }]}>
      {!!image && imageRenderer(image, width)}
      {showCloseButton && (<View style={[Styles.close, { width: R.spacing.l, height: R.spacing.l }]}>
          <DRNTouchableWrapper onPress={() => onCloseButtonPress()} smartKey={closeButtonSmartKey}>
            <View>
              <DRNImage source={require('../../../images/icSysCrossClose.png')} style={[{ width: R.spacing.l, height: R.spacing.l }, { tintColor }]}/>
            </View>
          </DRNTouchableWrapper>
        </View>)}
      {!!title && (<DRNText style={[Styles.title, showCloseButton && !image && { marginRight: R.spacing.m + R.spacing.l }]} variant="title-1">
          {title}
        </DRNText>)}
      <View style={Styles.content}>{children}</View>
    </View>);
}
Popup.propTypes = {
    width: PropTypes.number,
    maxWidth: PropTypes.number,
    minHeight: PropTypes.number,
    showCloseButton: PropTypes.bool,
    onCloseButtonPress: PropTypes.func,
    image: PropTypes.string,
    height: PropTypes.number,
    title: PropTypes.string,
    children: PropTypes.node,
    theme: PropTypes.object,
    closeButtonSmartKey: PropTypes.string,
};
Popup.defaultProps = {
    width: 320,
    maxWidth: 600,
    minHeight: 200,
    showCloseButton: false,
    onCloseButtonPress: () => null,
};
export default withTheme(Popup);
